import React, { Component } from "react";

const PageTitle = () => {
  return (
    <div className="page_title section-padding">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="page_title-content"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageTitle;
